import { Box, Divider, Paper, TextField, Typography } from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const DynamicAluminiumReport = ({
  mainData,
  setMainData,
  isNonMobile,
  coatingDesignation,
  tableValues,
  setTableValues,
}) => {
  // console.log("lab test data-", mainData);

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    coatingDesignation: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  useEffect(() => {
    calculateValues();
  }, [
    tableValues.baseThicknessValue,
    tableValues.averageThicknessValue,
    tableValues.totalThicknessValue,
  ]);

  const changeSpecifications = (value) => {
    if (value === "AZ150") {
      setTableValues((pre) => ({
        ...pre,
        baseThickness: 0.42,
        averageThickness: 54,
        totalThickness: 0.47,
      }));
    } else if (value === "AZ200") {
      setTableValues((pre) => ({
        ...pre,
        baseThickness: 0.42,
        averageThickness: 74,
        totalThickness: 0.47,
      }));
    }
  };

  const calculateValues = () => {
    setTableValues((pre) => ({
      ...pre,
      baseThicknessSatisfacory:
        Number(pre.baseThicknessValue === "" ? 0 : pre.baseThicknessValue) >=
        Number(pre.baseThickness)
          ? true
          : false,
      averageThicknessSatisfactory:
        Number(
          pre.averageThicknessValue === "" ? 0 : pre.averageThicknessValue
        ) >= Number(pre.averageThickness)
          ? true
          : false,
      totalThicknessSatisfacory:
        Number(pre.totalThicknessValue === "" ? 0 : pre.totalThicknessValue) >=
        Number(pre.totalThickness)
          ? true
          : false,
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <TextField
          select
          label="Coating Designation"
          fullWidth
          size="small"
          error={errorCheck.coatingDesignation.error}
          defaultValue=""
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.concreteMixture}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const selectedOption = coatingDesignation.find(
              (item) => item.value === selectedValue
            );
            console.log(selectedOption);
            setMainData((pre) => ({
              ...pre,
              concreteMixture: e.target.value,
            }));
            changeSpecifications(selectedValue);
          }}
        >
          {coatingDesignation.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper variant="elevation" elevation={2} sx={{ padding: "20px" }}>
          <Box
            display="grid"
            gap={0.5}
            alignItems="center"
            gridTemplateColumns="repeat(8, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 8",
              },
            }}
          >
            <Typography
              variant="h5"
              sx={{ gridColumn: "span 2" }}
              color="success"
              textAlign="center"
            >
              TESTS
            </Typography>

            <Typography
              variant="h5"
              sx={{ gridColumn: "span 2" }}
              color="success"
              textAlign="center"
            >
              SPECIFICATION
            </Typography>
            <Typography
              variant="h5"
              sx={{ gridColumn: "span 2" }}
              color="success"
              textAlign="center"
            >
              ENTER DATA
            </Typography>

            <Typography
              variant="h5"
              sx={{ gridColumn: "span 2" }}
              color="success"
              textAlign="center"
            >
              RESULT
            </Typography>
            <Divider sx={{ gridColumn: "span 8", marginBottom: "10px" }} />
            <Typography
              variant="h5"
              color="info"
              textAlign="start"
              sx={{ gridColumn: "span 2" }}
            >
              1. Base metal thickness (mm)
            </Typography>
            <Typography
              variant="h5"
              color="info"
              textAlign="center"
              sx={{ gridColumn: "span 2" }}
            >
              {Number(tableValues.baseThickness).toFixed(3)}
            </Typography>
            <TextField
              value={tableValues.baseThicknessValue}
              fullWidth
              variant="outlined"
              label="Metal thickness"
              onChange={(e) => {
                setTableValues((pre) => ({
                  ...pre,
                  baseThicknessValue: e.target.value,
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 2",
                "& input": {
                  textAlign: "right",
                },
              }}
            />
            <Typography
              variant="h5"
              color={tableValues.baseThicknessSatisfacory ? "success" : "error"}
              textAlign="center"
              sx={{
                gridColumn: "span 2",
              }}
            >
              {tableValues.baseThicknessSatisfacory
                ? "SATISFACTORY"
                : "NOT-SATISFACTORY"}
            </Typography>
            <Typography
              variant="h5"
              color="info"
              textAlign="start"
              sx={{ gridColumn: "span 2" }}
            >
              2. Average coating thickness (µm)
            </Typography>
            <Typography
              variant="h5"
              color="info"
              textAlign="center"
              sx={{ gridColumn: "span 2" }}
            >
              {Number(tableValues.averageThickness).toFixed(3)}
            </Typography>
            <TextField
              value={tableValues.averageThicknessValue}
              fullWidth
              variant="outlined"
              label="Top coating thickness"
              onChange={(e) =>
                setTableValues((pre) => ({
                  ...pre,
                  averageThicknessValue: e.target.value,
                }))
              }
              type="number"
              size="small"
              sx={{
                gridColumn: "span 2",
                marginTop: "8px",
                "& input": {
                  textAlign: "right",
                },
              }}
            />
            <Typography
              variant="h5"
              color={
                tableValues.averageThicknessSatisfactory ? "success" : "error"
              }
              textAlign="center"
              sx={{
                gridColumn: "span 2",
              }}
            >
              {tableValues.averageThicknessSatisfactory
                ? "SATISFACTORY"
                : "NOT-SATISFACTORY"}
            </Typography>

            <Typography
              variant="h5"
              color="info"
              textAlign="start"
              sx={{ gridColumn: "span 2" }}
            >
              3. Total coated thickness (mm)
            </Typography>
            <Typography
              variant="h5"
              color="info"
              textAlign="center"
              sx={{ gridColumn: "span 2" }}
            >
              {Number(tableValues.totalThickness).toFixed(3)}
            </Typography>
            <TextField
              value={tableValues.totalThicknessValue}
              fullWidth
              variant="outlined"
              label="Metal thickness"
              type="number"
              size="small"
              onChange={(e) =>
                setTableValues((pre) => ({
                  ...pre,
                  totalThicknessValue: e.target.value,
                }))
              }
              sx={{
                gridColumn: "span 2",
                marginTop: "8px",

                "& input": {
                  textAlign: "right",
                },
              }}
            />
            <Typography
              variant="h5"
              color={
                tableValues.totalThicknessSatisfacory ? "success" : "error"
              }
              textAlign="center"
              sx={{
                gridColumn: "span 2",
              }}
            >
              {tableValues.totalThicknessSatisfacory
                ? "SATISFACTORY"
                : "NOT-SATISFACTORY"}
            </Typography>
          </Box>
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default DynamicAluminiumReport;
